import styled from 'styled-components';

export const OlympiadsPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100%;
  gap: 20px;
`;

export const OlympiadsPageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const OlympiadsTitle = styled.h2`
  margin: 0;
  font-weight: 700;
  font-size: 40px;
  line-height: 48px;
  color: var(--font-color);
`;

export const OlympiadsContent = styled.div<{ $stretch?: boolean }>`
  display: flex;
  align-items: ${({ $stretch }) => ($stretch ? 'stretch' : 'flex-start')};
  flex: ${({ $stretch }) => ($stretch ? 1 : 'initial')};
  gap: 16px;
  width: 100%;
  min-height: 0;
`;

export const OlympiadsMain = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OlympiadsSidebar = styled.aside`
  position: sticky;
  top: calc(var(--main-header-height) + var(--main-header-sticky-gap));
  z-index: 2;
  flex-shrink: 0;
  align-self: flex-start;
  width: 288px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SidebarCardTitle = styled.h3`
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  color: var(--font-color);
`;

export const OlympiadsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export const OlympiadsListLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  width: 100%;
`;
